module.exports = __webpack_public_path__ + "static/media/bicycle.bd870a0c.svg";